import React, { useState } from "react";
import ApiConnect from "../../Utils/ApiConnect";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
export default function ForgotPasswd() {
  const [username, setUsername] = useState("");
  const submitHandler = (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("username", username);
    ApiConnect({
      method: "post",
      url: "/Auth/UserLogin/ForgotPassword",
      data: formData,
    })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          setUsername("");
          window.location = "/";
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <>
      <div className="px-30 w-400px mx-auto">
        <h3 className="header-title">
          <strong>Password Reset</strong>
        </h3>
        <p>Reset Password by entering information below.</p>
        <form className="form" onSubmit={(e) => submitHandler(e)}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              className="form-control"
              required
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <br />
          <div className="form-group">
            <button
              className="w-50 btn btn-bold btn-block btn-info"
              type="submit"
            >
              Reset
            </button>
            <Link
              to="/"
              className="w-50 btn btn-secondary btn-block btn-primary"
            >
              Login
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}
